import { flipFlop } from '@mq/volt-amc-container';

const showCollateralColumn = flipFlop.get('commercial-credit', false);
export const filterColumns = (columns) => {
  return !showCollateralColumn
    ? columns.filter((column) => column.header !== 'Collateral amount')
    : columns;
};
